<template>
  <div class="map">
    <div class="app-container">
      <div id="chinaMap"></div>
      <div class="mapChoose">
        <span v-for="(item, index) in parentInfo" :key="item.code">
          <span class="title" @click="chooseArea(item, index)">{{
            item.cityName == "全国" ? "中国" : item.cityName
          }}</span>
          <span class="icon" v-show="index + 1 != parentInfo.length">></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AMapJS from "amap-js";
import resize from "../../mixins/resize";
import echarts4 from "echarts4";
import { getdata } from "@/api/map";
import worldJson from "@/assets/json/world.json"; 

export default {
  name: "home",
  components: {},
  data() {
    return {
      amapLoader: new AMapJS.AMapLoader({
        key: "7dffec604fbe401935b33f4afb903688",
        version: "1.4.15",
        plugins: [],
      }),
      amapuiLoader: new AMapJS.AMapUILoader({ version: "1.0" }),
      timeTitle: ["2024"],
      parentInfo: [
        {
          cityName: "世界",
          code: "world",
          level: "world",
        },
      ],
      geoJson: { features: [] },
      randomData: [],
      // 中国地理中心点坐标（东经103.8198°，北纬36.56°）
      chinaCenter: [103.8198, 36.56],
      // 世界地图下中国居中的缩放比例
      worldZoom: 3.5,
    };
  },
  mixins: [resize],
  methods: {
    getinfodata() {
      this.randomData = this.generateRandomData(500);
    },

    async getGeoJson(code) {
      // 强制重置：回到世界时，深拷贝worldJson，确保数据干净
      if (code === "world") {
        this.geoJson = JSON.parse(JSON.stringify(worldJson));
        this.getMapData();
        return;
      }

      // 中国行政区逻辑
      await this.amapLoader.load();
      await this.amapuiLoader.load();

      let that = this;
      AMapUI.loadUI(["geo/DistrictExplorer"], (DistrictExplorer) => {
        let districtExplorer = new DistrictExplorer();
        districtExplorer.loadAreaNode(code, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }
          let Json = areaNode.getSubFeatures();
          if (Json.length > 0) {
            that.geoJson.features = Json;
          } else {
            that.geoJson.features = that.geoJson.features.filter(
              (item) => item.properties.adcode == code
            );
            if (that.geoJson.features.length === 0) return;
          }
          that.getMapData();
        });
      });
    },

    isPointInPolygon(point, polygon) {
      const [px, py] = point;
      const [polygonPoints] = polygon;
      let isInside = false;
      let n = polygonPoints.length;

      for (let i = 0, j = n - 1; i < n; j = i++) {
        const [xi, yi] = polygonPoints[i];
        const [xj, yj] = polygonPoints[j];
        const intersect =
          yi > py !== yj > py && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
      }
      return isInside;
    },

    getMapData() {
      let mapData = {},
        pointData = {},
        sum = {};

      for (let i = 0; i < this.timeTitle.length; i++) {
        let time = this.timeTitle[i];
        mapData[time] = [];
        pointData[time] = [];
        sum[time] = 0;

        let last = this.parentInfo.at(-1);
        let level = last.level;

        for (let j = 0; j < this.geoJson.features.length; j++) {
          let feat = this.geoJson.features[j];
          let name = feat.properties.name || feat.properties.NAME || "未知";
          let code = feat.properties.adcode || name;
          let value = this.getRandomInt(1, 100);

          mapData[time].push({
            name,
            value,
            level,
            cityCode: code,
          });

          pointData[time].push({
            name,
            value: [],
            cityCode: code,
          });

          sum[time] += value;
        }

        mapData[time].sort((a, b) => b.value - a.value);
      }

      this.drawChinaMap(mapData, pointData, sum);
    },

    drawChinaMap(mapData, pointData, sum) {
      // 每次渲染前销毁旧实例，清空缓存
      const dom = document.getElementById("chinaMap");
      if (dom._echartsInstance) {
        dom._echartsInstance.dispose();
      }
      let mapChart = echarts4.init(dom);
      dom._echartsInstance = mapChart;

      let last = this.parentInfo.at(-1);

      // 严格按level注册地图
      if (last.level === "world") {
        echarts4.registerMap("world", this.geoJson);
      } else if (last.level === "china") {
        echarts4.registerMap("china", this.geoJson);
      } else {
        echarts4.registerMap("map", this.geoJson);
      }

      let option = {
        graphic: [
          {
            type: "rect",
            z: 0,
            shape: { x: 0, y: 0, width: "100%", height: "100%" },
            style: {
              fill: "linear-gradient(135deg, #0a1929 10%, #112244 100%)",
            },
          },
        ],
        timeline: {
          data: this.timeTitle,
          axisType: "category",
          autoPlay: true,
          playInterval: 3000,
          left: "10%",
          right: "10%",
          bottom: "2%",
          label: {
            normal: { textStyle: { color: "#b3efff" } },
            emphasis: { textStyle: { color: "#fff" } },
          },
          symbolSize: 10,
          lineStyle: { color: "#8df4f4" },
          checkpointStyle: { borderColor: "#8df4f4", color: "#53D9FF" },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: { color: "#53D9FF", borderColor: "#53D9FF" },
          },
        },
        baseOption: {
          animation: true,
          tooltip: { trigger: "axis" },
          grid: { right: "2%", top: "12%", bottom: "8%", width: "20%" },
          toolbox: {
            feature: {
              dataView: {},
            },
            top: 15,
            right: 35,
          },
          geo: {
            // 按level选择地图类型
            map: last.level === "world" ? "world" : (last.level === "china" ? "china" : "map"),
            roam: true,
            // 核心：世界地图用中国居中的缩放比例，其他层级用原有比例
            zoom: last.level === "world" ? this.worldZoom : 1.1,
            // 核心：世界地图中心点设为中国地理中心，其他层级按原有逻辑
            center: last.level === "world" 
              ? this.chinaCenter 
              : (last.level === "china" ? ["118.83531246", "32.0267395887"] : false),
            label: {
              normal: {
                show: true,
                color: "#f9f9f9",
                formatter: (p) => {
                  switch (p.name) {
                    case "内蒙古自治区": return "内蒙古";
                    case "西藏自治区": return "西藏";
                    case "新疆维吾尔自治区": return "新疆";
                    case "宁夏回族自治区": return "宁夏";
                    case "广西壮族自治区": return "广西";
                    case "香港特别行政区": return "香港";
                    case "澳门特别行政区": return "澳门";
                    default: return p.name;
                  }
                },
              },
              emphasis: { show: true,color: "#f75a00" },
            },
            itemStyle: {
              normal: {
                areaColor: "#24CFF4",
                borderColor: "#53D9FF",
                borderWidth: 1.3,
                shadowBlur: 15,
                shadowColor: "rgb(58,115,192)",
                shadowOffsetX: 7,
                shadowOffsetY: 6,
              },
              emphasis: { areaColor: "#8dd7fc", borderWidth: 1.6, shadowBlur: 25 },
            },
          },
        },
        options: [],
      };

      this.timeTitle.forEach((time) => {
        let xData = [], yData = [];
        let list = mapData[time];
        let min = list.length ? list.at(-1).value : 0;
        let max = list.length ? list[0].value : 100;
        if (list.length === 1) min = 0;

        list.forEach((c) => {
          xData.unshift(c.name);
          yData.unshift(c.value);
        });

        option.options.push({
          title: [
            {
              left: "center",
              top: 0,
              text: `${time} ${last.cityName} 景区统计图(可点击下钻到市/区)`,
              textStyle: { color: "#b3efff", fontSize: 16 },
            },
            {
              text: `景区总览：${sum[time].toFixed(0)}个`,
              left: "center",
              top: "6.5%",
              textStyle: { color: "#FFAC50", fontSize: 26 },
            },
          ],
          visualMap: {
            min,
            max,
            left: "3%",
            bottom: "5%",
            calculable: true,
            inRange: { color: ["#24CFF4", "#2E98CA", "#1E62AC"] },
            textStyle: { color: "#24CFF4" },
          },
          xAxis: {
            type: "value",
            scale: true,
            position: "top",
            splitLine: { show: false },
            axisLine: { lineStyle: { color: "#455B77" } },
            axisLabel: { color: "#c0e6f9" },
          },
          yAxis: {
            type: "category",
            axisLine: { lineStyle: { color: "#455B77" } },
            axisLabel: { color: "#c0e6f9" },
            data: xData,
          },
          series: [
            {
              type: "map",
              geoIndex: 0,
              // series层级map与geo完全同步
              map: last.level === "world" ? "world" : (last.level === "china" ? "china" : "map"),
              roam: true,
              // series层级缩放与geo同步
              zoom: last.level === "world" ? this.worldZoom : 1.3,
              tooltip: {
                formatter: (p) => {
                  if (!p.value || p.name === "南海诸岛") return p.name;
                  if (window.isNaN(p.value)) p.value = 0;
                  if (p.name === "中国" && last.level === "world") {
                    return `<div style='text-align:left'>${p.name}<br/>点击进入中国景区详情</div>`;
                  }
                  return `<div style='text-align:left'>${p.name}<br/>景区：${p.value.toFixed(0)}个</div>`;
                },
              },
              label: {
                normal: { show: false },
                emphasis: { show: false },
              },
              data: mapData[time],
            },
            {
              type: "effectScatter",
              coordinateSystem: "geo",
              data: pointData[time],
              symbolSize: (val) => (val[2] === max ? 27 : 10),
              label: { normal: { show: false } },
              itemStyle: { color: "#F4E925" },
            },
            {
              type: "bar",
              barGap: "-100%",
              barCategoryGap: "60%",
              itemStyle: { color: "#11AAFE" },
              data: yData,
            },
          ],
        });
      });

      mapChart.setOption(option, true);
      mapChart.off("click");
      mapChart.on("click", this.echartsMapClick);
      
      window.addEventListener('resize', () => {
        mapChart.resize();
      });
    },

    echartsMapClick(params) {
      if (!params.data) return;
      let { name, cityCode } = params.data;
      let last = this.parentInfo.at(-1);

      if (last.code === cityCode) return;

      if (last.level === "world") {
        if (name === "中国" || name === "China") {
          this.parentInfo.push({
            cityName: "中国",
            code: 100000,
            level: "china",
          });
          this.getGeoJson(100000);
        }
        return;
      }

      this.parentInfo.push({
        cityName: name,
        level: "region",
        code: cityCode,
      });
      this.getGeoJson(cityCode);
    },

    chooseArea(val, index) {
      if (this.parentInfo.length === index + 1) return;
      this.parentInfo.splice(index + 1);
      // 回退时销毁旧实例
      const dom = document.getElementById("chinaMap");
      if (dom._echartsInstance) {
        dom._echartsInstance.dispose();
      }
      this.$nextTick(() => {
        this.getGeoJson(this.parentInfo.at(-1).code);
      });
    },

    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getRandomFloat(min, max, decimalPlaces) {
      const factor = 10 ** decimalPlaces;
      return (Math.random() * (max - min) + min).toFixed(decimalPlaces);
    },
    generateRandomData(numRecords) {
      const data = [];
      const minLat = -53, maxLat = 72;
      const minLon = -180, maxLon = 180;
      for (let i = 0; i < numRecords; i++) {
        data.push({
          areaCode: this.getRandomInt(10000, 99999).toString(),
          areaName: `Area ${this.getRandomInt(1, 100)}`,
          center: `${this.getRandomFloat(minLat, maxLat, 6)},${this.getRandomFloat(minLon, maxLon, 6)}`,
          store_count: this.getRandomInt(1, 10),
        });
      }
      return data;
    },
  },
  mounted() {
    this.getinfodata();
    this.getGeoJson("world");
    this.$nextTick(() => {
      const dom = document.getElementById("chinaMap");
      if (dom._echartsInstance) {
        dom._echartsInstance.resize();
      }
    });
  },
};
</script>





<style lang="scss" scoped>
.map {
  position: relative;
  background-color: rgba(1, 34, 72, 0.5) !important;
  background-image: url("https://invengo-card.oss-cn-shanghai.aliyuncs.com/cd157f2b7d32a21acf060c55255da8bd.gif") !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  width: 100%;
  height: 100%;
}
.app-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  #chinaMap {
    width: 100%;
    height: 800px;
    background: none !important;
  }
  .mapChoose {
    position: absolute;
    left: 20px;
    top: 20px;
    color: rgb(147, 235, 248);
    z-index: 100;
    .title {
      padding: 5px;
      border-top: 1px solid rgba(147, 235, 248, 0.8);
      border-bottom: 1px solid rgba(147, 235, 248, 0.8);
      cursor: pointer;
    }
    .icon {
      font-family: "simsun";
      font-size: 25px;
      margin: 0 11px;
    }
  }
}
</style>